// extracted by mini-css-extract-plugin
export var active = "SwitchButtons-module--active--3a589";
export var button = "SwitchButtons-module--button--cd0fd";
export var description = "SwitchButtons-module--description--04d97";
export var icon = "SwitchButtons-module--icon--fab04";
export var switchSpacer = "SwitchButtons-module--switchSpacer--cbe50";
export var switchWrapper = "SwitchButtons-module--switchWrapper--b0246";
export var title = "SwitchButtons-module--title--a78fb";